import { render, staticRenderFns } from "./PisCofinsCreditNcmList.vue?vue&type=template&id=e4094ca4&scoped=true&lang=pug&"
import script from "./PisCofinsCreditNcmList.vue?vue&type=script&setup=true&lang=js&"
export * from "./PisCofinsCreditNcmList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PisCofinsCreditNcmList.vue?vue&type=style&index=0&id=e4094ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4094ca4",
  null
  
)

export default component.exports